import * as Yup from 'yup';
import SelectQuestion from '../SelectQuestion/SelectQuestion';
import { createLocalizedOptions } from '../../pages/root/App';
import messages from '../PvESocialHabits/messages';
import siteMessages from '../../pages/root/siteMessages';
import { socialHabits } from '../../utils/constants';
import { useEffect } from 'react';
import { useIntl } from 'react-intl';

interface Props {
  values: any;
  errors: any;
  setFieldValue: any;
  updateSchema: (value: any) => void;
}

const PvPSocialHabits = ({
  values,
  errors,
  setFieldValue,
  updateSchema
}: Props) => {
  const intl = useIntl();

  const socialHabitsOptions = createLocalizedOptions(socialHabits, messages);

  useEffect(() => {
    const PvPSocialHabitsSchema = {
      socialHabitPvpIds: Yup.array(Yup.number()).min(
        1,
        intl.formatMessage({ ...siteMessages.FIELD_REQUIRED })
      )
    };
    updateSchema(PvPSocialHabitsSchema);
  }, []);

  return (
    <SelectQuestion
      controlId="socialHabitPvpIds"
      label={intl.formatMessage({ ...messages.socialHabitsPvP })}
      isMulti={true}
      options={socialHabitsOptions}
      value={values.socialHabitPvpIds}
      error={errors.socialHabitPvpIds}
      setFieldValue={setFieldValue}
    />
  );
};

export default PvPSocialHabits;
